/* Christmas landing page behaviour (sections/christmas-landing.liquid).
   Everything is scoped to the .jm-xmas root and degrades gracefully without JS. */
(function () {
  'use strict';

  var root = document.querySelector('.jm-xmas');
  if (!root) return;

  // Lets the CSS hide the site announcement bar on this page only (fallback for browsers without :has()).
  document.body.classList.add('jm-xmas-on');

  /* ---- Tabs: "Who are you shopping for?" --------------------------------- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

  function selectTab(tab, moveFocus) {
    tabs.forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-active', active);
    });
    if (moveFocus) tab.focus();
    if (tab.scrollIntoView && window.matchMedia('(max-width: 989px)').matches) {
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    // Judge.me badges in a newly shown panel may need a nudge to render.
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try {
        window.jdgm.customizeBadges();
      } catch (e) {}
    }
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      selectTab(tab, false);
    });
    tab.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') next = tabs[0];
      else if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) {
        e.preventDefault();
        selectTab(next, true);
      }
    });
  });

  // Ads can deep-link to a tab: ?for=grandma
  try {
    var wanted = new URLSearchParams(window.location.search).get('for');
    if (wanted) {
      wanted = wanted.toLowerCase();
      var match = tabs.filter(function (t) {
        return t.getAttribute('data-slug') === wanted;
      })[0];
      if (match) selectTab(match, false);
    }
  } catch (e) {}

  /* ---- Countdown to the order deadline ----------------------------------- */
  var clock = root.querySelector('[data-jm-xmas-countdown]');
  if (clock) {
    var end = new Date(root.getAttribute('data-deadline')).getTime();
    var d = clock.querySelector('[data-jm-xmas-d]');
    var h = clock.querySelector('[data-jm-xmas-h]');
    var m = clock.querySelector('[data-jm-xmas-m]');
    var tick = function () {
      var left = end - Date.now();
      if (isNaN(left) || left <= 0) {
        clock.style.display = 'none';
        return false;
      }
      d.textContent = Math.floor(left / 86400000);
      h.textContent = Math.floor((left % 86400000) / 3600000);
      m.textContent = Math.floor((left % 3600000) / 60000);
      return true;
    };
    if (tick()) {
      var timer = setInterval(function () {
        if (!tick()) clearInterval(timer);
      }, 30000);
    }
  }

  /* ---- Copy code ---------------------------------------------------------- */
  var copyBtn = root.querySelector('[data-jm-xmas-copy]');
  if (copyBtn) {
    var label = copyBtn.querySelector('[data-jm-xmas-copy-label]');
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-jm-xmas-copy');
      var done = function () {
        if (!label) return;
        label.textContent = 'Copied!';
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          label.textContent = 'Copy';
          copyBtn.classList.remove('is-copied');
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        done();
      }
    });
  }

  /* ---- Auto-apply the discount code for this session --------------------- */
  var code = root.getAttribute('data-code');
  if (code && root.getAttribute('data-offer-active') === 'true' && !(window.Shopify && window.Shopify.designMode)) {
    try {
      var key = 'jm_xmas_discount_' + code;
      if (!sessionStorage.getItem(key)) {
        // Shopify stores the code in a cookie and applies it at checkout.
        // Redirecting to /cart.js keeps the response tiny.
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), {
          credentials: 'same-origin'
        })
          .then(function () {
            sessionStorage.setItem(key, '1');
          })
          .catch(function () {});
      }
    } catch (e) {}
  }

  /* ---- Sticky mobile CTA: show once the hero button has scrolled away ----- */
  var sticky = root.querySelector('[data-jm-xmas-sticky]');
  var heroCta = root.querySelector('.jm-xmas-hero [data-jm-xmas-cta]');
  var finalSection = root.querySelector('.jm-xmas-final');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    var heroGone = false;
    var finalSeen = false;
    var toggle = function () {
      var show = heroGone && !finalSeen;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = sticky.querySelector('a');
      if (link) link.setAttribute('tabindex', show ? '0' : '-1');
    };
    new IntersectionObserver(function (entries) {
      heroGone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      toggle();
    }).observe(heroCta);
    if (finalSection) {
      new IntersectionObserver(function (entries) {
        finalSeen = entries[0].isIntersecting;
        toggle();
      }).observe(finalSection);
    }
  }
})();
